const Paragraph = ({ content, style }) => {
    return <p style={style}>{content}</p>
}

export default Paragraph;